module.exports = "/_next/static/images/shouvik-paul-b4174d3c906af707dc69c65a9702684a.jpg";